import { render, staticRenderFns } from "./fallback.vue?vue&type=template&id=3f613ee8&scoped=true&"
import script from "./fallback.vue?vue&type=script&lang=js&"
export * from "./fallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f613ee8",
  null
  
)

export default component.exports